/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */

const state = {
  empresa: null,
  escolherEmpresa: null,
}

const getters = {
  empresa: state_ => {
    const salvo = !state_.empresa ? JSON.parse(localStorage.getItem('empresaSelecionada')) || {} : state_.empresa
    return salvo
  },
  escolherEmpresa: state_ => {
    const empresasSalvas = localStorage.getItem('userData')
    if (state_.escolherEmpresa) { return true }

    const salvo = !state_.escolherEmpresa && empresasSalvas ? JSON.parse(empresasSalvas) : {}
    return !!(salvo && salvo.empresas.length !== 1)
  },
}

const actions = {
  setEmpresa({ commit }, empresa) {
    commit('SET_EMPRESA_GLOBAL', empresa)
  },
  setEscolherEmpresa({ commit }, escolher) {
    commit('SET_ESCOLHER_EMPRESA', escolher)
  },
}

const mutations = {
  SET_EMPRESA_GLOBAL(state_, empresa) {
    state_.empresa = empresa
    localStorage.setItem('empresaSelecionada', JSON.stringify(empresa))
  },
  SET_ESCOLHER_EMPRESA(state_, empresa) {
    state_.escolherEmpresa = empresa
  },
}

export default {
  namespaced: true,
  getters,
  actions,
  mutations,
  state: () => state,
}
